import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AuthService, SiteUser } from '../../services/Auth/auth.service';
import { Router } from '@angular/router';
import { PhoneMaskDirective } from '../../directives/phone-mask.directive';
import { passwordMatchValidator } from '../../services/Auth/passwordMatchValidator';

@Component({
    selector: 'app-register-page',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatCheckboxModule,
        PhoneMaskDirective
    ],
    templateUrl: './register-page.component.html',
    styleUrl: './register-page.component.scss'
})
export class RegisterPageComponent {
    private fb = inject(FormBuilder);
    private authService = inject(AuthService);
    private router = inject(Router);
    public salesMatchesUser: boolean = true

    registerForm: FormGroup;
    error: string | null = null;

    constructor() {
        this.registerForm = this.fb.group({
            user: this.fb.group({
                firstName: ['', Validators.required],
                lastName: ['', Validators.required],
                title: ['', Validators.required],
                phone: ['', [Validators.required, Validators.pattern(/^\(\d{3}\) \d{3}-\d{4}$/)]],
                email: ['', [Validators.required, Validators.email]],
            }),
            sales: this.fb.group({
                salesMatchesUser: [true],
                firstName: ['', this.salesMatchesUser ? null : Validators.required ],
                lastName: ['', this.salesMatchesUser ? null : Validators.required],
                title: ['', this.salesMatchesUser ? null : Validators.required],
                phone: ['', this.salesMatchesUser ? null :  [Validators.required, Validators.pattern(/^\(\d{3}\) \d{3}-\d{4}$/)]],
                email: ['', this.salesMatchesUser ? null : [Validators.required, Validators.email]],
            }),
            theaters: this.fb.array([]),
            password: ['', [Validators.required, Validators.minLength(6)]],
            confirmPassword: ['', [Validators.required]]
        }, { validators: passwordMatchValidator });
    }

    /* Called on each input in either password field */
    onPasswordInput() {
        // if(this.registerForm && this.registerForm.errors) {
            // console.log('Input error: ' + this.registerForm.errors['passwordMismatch'] )
        // }
        if (this.registerForm.hasError('passwordMismatch')) {
            this.registerForm.get('confirmPassword')?.setErrors([{ 'passwordMismatch': true }]);
        }
        else {
            this.registerForm.get('confirmPassword')?.setErrors(null);
        }
    }

    toggleSalesUser() {
        this.salesMatchesUser = this.registerForm.get('sales')?.value.salesMatchesUser
    }

    get theaters(): FormArray {
        return this.registerForm.get('theaters') as FormArray;
    }

    addTheater(): void {
        const theaterGroup = this.fb.group({
            name: ['', Validators.required],
            address: this.fb.group({
                city: ['', Validators.required],
                zip: ['', [Validators.required, Validators.pattern(/^\d{5}$/)]],
                adress: ['', Validators.required],
                state: ['', Validators.required]
            }),
            phone: ['', [Validators.required, Validators.pattern(/^\(\d{3}\) \d{3}-\d{4}$/)]],
            preferredFormat: ['', Validators.required],
            admissionCharges: [false]
        });
        this.theaters.push(theaterGroup);
    }

    removeTheater(index: number): void {
        this.theaters.removeAt(index);
    }

    userUpdate() {
        if(this.salesMatchesUser) {
            
        }
    }

    onSubmit(): void {
        if (this.registerForm.valid) {
            // const siteUser: SiteUser = {
            //     id: '',
            //     user: this.registerForm.get('user')?.value,
            //     sales: this.registerForm.get('sales')?.value,
            //     theaters: this.registerForm.get('theaters')?.value,
            //     approved: false,
            // };
            // const { password } = this.registerForm.value;
            // const email = siteUser.user.email

            // this.authService.register(siteUser, email, password).subscribe({
            //     next: () => this.router.navigateByUrl('/pending-approval'),
            //     error: (err) => {
            //         this.error = err.message;
            //         console.error('Registration error:', err);
            //     }
            // });
        }
    }
}